export default __webpack_public_path__ + "static/media/arrow-down-green.f933ed4e.svg";